export default "__VITE_ASSET__3c0208b7__"